import * as React from "react"
import {PriceEvolutionBaseWidget} from "../../@components";


export default function PriceEvolutionWidgetLegend({ isPercentage, isSplitBySku }) {
    return <PriceEvolutionBaseWidget
        title={isSplitBySku ? 'Retailer' : 'SKU'}
        current={isPercentage ? 'X%' : 'XX Currency'}
        previous={isPercentage ? 'X%' : 'XX Currency'}
        sx={{ backgroundColor: 'background.neutral' }}
        customDiff={isPercentage ? "Xp.p." : "X%"}
        fontTooltip="0.675rem"
        minValue="X%"
        maxDates={null}
        maxValue="X%"
        minDates={null}
        labelTooltipMax={`Max ${isPercentage ? 'Discount' : 'Price'} (% days)`}
        labelTooltipMin={`Min ${isPercentage ? 'Discount' : 'Price'} (% days)`}
    />
}